import OmniApiClient from "./base";
import {
  buildPennerCacheKey,
  clearPennerCache,
  getPennerCache,
  setPennerCache,
} from "./pennerManagementCache";

const asCachedResponse = (data) => ({
  data,
  status: 200,
  statusText: "OK",
  headers: {},
  config: {},
  fromCache: true,
});

const withCache = async (cacheKey, fetcher, { forceRefresh = false } = {}) => {
  if (!forceRefresh) {
    const cached = getPennerCache(cacheKey);
    if (cached !== null) {
      return asCachedResponse(cached);
    }
  }

  const response = await fetcher();
  setPennerCache(cacheKey, response.data);
  return response;
};

export const pennerManagementApi = {
  getSales: (params = {}, options = {}) => {
    const {
      period = "30d",
      search = "",
      skip = 0,
      limit = 100,
      article_type = "penner",
    } = typeof params === "string" ? { period: params } : params;
    const query = {
      period,
      skip,
      limit,
      article_type,
      ...(search?.trim() ? { search: search.trim() } : {}),
    };
    const cacheKey = buildPennerCacheKey("sales", query);
    return withCache(
      cacheKey,
      () => OmniApiClient.get("/penner/sales", { params: query }),
      options,
    );
  },

  getArticles: (params = {}, options = {}) => {
    const {
      sort_by = "sales_30d",
      sort_dir = "desc",
      search = "",
      stock_age_bucket = null,
      skip = 0,
      limit = 100,
      article_type = "penner",
    } = params;
    const query = {
      sort_by,
      sort_dir,
      skip,
      limit,
      article_type,
      ...(search?.trim() ? { search: search.trim() } : {}),
      ...(stock_age_bucket ? { stock_age_bucket } : {}),
    };
    const cacheKey = buildPennerCacheKey("articles", query);
    return withCache(
      cacheKey,
      () => OmniApiClient.get("/penner/articles", { params: query }),
      options,
    );
  },

  getArticleInsights: (sku, options = {}) => {
    const { article_type = "penner", ...cacheOptions } = options;
    const cacheKey = buildPennerCacheKey("insights", { sku, article_type });
    return withCache(
      cacheKey,
      () =>
        OmniApiClient.get(
          `/penner/articles/${encodeURIComponent(sku)}/insights`,
          { params: { article_type } },
        ),
      cacheOptions,
    );
  },

  clearCache: clearPennerCache,
};
